import { NgModule } from '@angular/core';

import { SharedModule } from '../../shared/shared.module';
import { DatePipe } from '@angular/common';
import { AvisoRoutingModule } from './aviso-routing.module';
import { AvisoPesquisaComponent } from './aviso-pesquisa.component';
import { AvisoListagemComponent } from './aviso-listagem.component';
import { AvisoCadastroComponent } from './aviso-cadastro.component';

@NgModule({
  imports: [
	  SharedModule,
    AvisoRoutingModule
  ],
  declarations: [
	  AvisoPesquisaComponent,
    AvisoListagemComponent,
    AvisoCadastroComponent,
  ],
  providers: [
    DatePipe
  ]
})
export class AvisoModule { }
